import React, { Fragment } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import FounderContact from './FounderContact';
import { foundersData } from '../../../constants';


const FoundersWrapper = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 1fr);
  grid-gap: 50px 0;
  margin-top: 50px;
  margin-bottom: 200px;
  word-break: break-word;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.small}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-gap: 50px 20px;
  } 
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    grid-gap: 50px 30px;
  } 
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    grid-gap: 0 30px;
    margin: 30px 0 20px 0;
  } 
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    grid-gap: 0 50px;
  } 
`;


const FoundersContact = () => {
  const { t } = useTranslation();
    
  return (
    <FoundersWrapper>
      {foundersData.map((founder) => (
        <Fragment key={founder.name}>
          <FounderContact
            name={founder.name}
            position={t(founder.position)}
            job={t(founder.job)}
            email={founder.email}
            phoneNumber={founder.phoneNumber}
          />
        </Fragment>
      ))}
    </FoundersWrapper>
  );
};

export default FoundersContact;
